import { render } from "./lrbTable2.vue?vue&type=template&id=5a2b68d2&scoped=true"
import script from "./lrbTable2.vue?vue&type=script&lang=js"
export * from "./lrbTable2.vue?vue&type=script&lang=js"

import "./lrbTable2.vue?vue&type=style&index=0&id=5a2b68d2&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a2b68d2"]])

export default __exports__